var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66667 0.666668H12.3333C13.0667 0.666668 13.6667 1.26667 13.6667 2V10C13.6667 10.7333 13.0667 11.3333 12.3333 11.3333H1.66667C0.933336 11.3333 0.333336 10.7333 0.333336 10L0.340003 2C0.340003 1.26667 0.933336 0.666668 1.66667 0.666668ZM7.35334 6.44667L12.0667 3.5C12.2333 3.39333 12.3333 3.21333 12.3333 3.02C12.3333 2.57333 11.8467 2.30667 11.4667 2.54L7 5.33333L2.53334 2.54C2.15334 2.30667 1.66667 2.57333 1.66667 3.02C1.66667 3.21333 1.76667 3.39333 1.93334 3.5L6.64667 6.44667C6.86 6.58 7.14 6.58 7.35334 6.44667Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.43400c5d8aa26b0b02c9b2ae731834f2.svg";
export { ForwardRef as ReactComponent };